import Alcaal from "../assets/img/png/10003.png";
import Capricha from "../assets/img/png/10004.png";
import GEDS from "../assets/img/png/10005.png";
import Idalzira from "../assets/img/png/10006.png";
import Oasis from "../assets/img/png/10007.png";
import TextAng from "../assets/img/png/10008.png";
import Yurman from "../assets/img/png/10009.png";
import {
  faSnowflake,
  faBolt,
  faBuilding,
  faFaucet,
  faPaintRoller,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";
import Repair from "../assets/img/png/10010.png";
import Car from "../assets/img/jpeg/10001.jpeg";
import Installation from "../assets/img/png/10011.png";
import Maintain from "../assets/img/jpg/10002.jpg";
import { IFAQItem, IService } from "../interfaces/index";

export const services: IService[] = [
  {
    title: "Climatização e Ar Condicionado",
    description:
      "Soluções completas em sistemas de climatização residencial, comercial e automotiva, incluindo instalação, manutenção preventiva e corretiva, limpeza técnica e reparação de todos os tipos de equipamentos de ar condicionado.",
    icon: faSnowflake,
    content: [
      {
        image: Installation,
        title: "Instalação de Ar Condicionado",
        description:
          "Realizamos a instalação de ar condicionado de forma profissional e eficiente. Nossa equipe garante a correta configuração do sistema, maximizando a performance e a economia de energia, para que você tenha um ambiente sempre confortável.",
        benefits: [
          "Instalação rápida",
          "Suporte pós-venda",
          "Garantia de 1 ano no serviço",
        ],
        link: "/solicitar-instalacao",
      },
      {
        image: Maintain,
        title: "Manutenção de Ar Condicionado",
        description:
          "A manutenção regular é essencial para o bom funcionamento do seu ar condicionado. Oferecemos serviços de manutenção preventiva e corretiva, identificando possíveis falhas e evitando paradas inesperadas.",
        benefits: [
          "Prevenção de avarias",
          "Aumento da durabilidade",
          "Limpeza especializada",
        ],
        link: "/solicitar-manutencao",
      },
      {
        image: Repair,
        title: "Reparação de Ar Condicionado",
        description:
          "Se o seu ar condicionado está apresentando falhas, nossa equipe está pronta para resolver. Oferecemos diagnósticos rápidos e reparos precisos, garantindo que seu sistema volte a funcionar com total eficiência.",
        benefits: [
          "Atendimento rápido",
          "Técnicos especializados",
          "Uso de peças originais",
        ],
        link: "/solicitar-reparacao",
      },
      {
        image: Car,
        title: "Ar Condicionado de Veículos",
        description:
          "Manter o ar condicionado do seu veículo em boas condições é fundamental para viagens confortáveis. Realizamos tanto reparos quanto manutenções preventivas em sistemas de ar condicionado automotivos.",
        benefits: [
          "Serviço especializado",
          "Equipamentos modernos",
          "Garantia de conforto térmico",
        ],
        link: "/solicitar-veiculos",
      },
    ],
  },
  {
    title: "Serviços Elétricos",
    description:
      "Instalações elétricas prediais e residenciais completas, montagem de quadros de distribuição, manutenção preventiva de sistemas elétricos, reparação de circuitos, instalação de pontos de energia e iluminação, adequação às normas técnicas de segurança.",
    icon: faBolt,
    content: [
      {
        image: Installation,
        title: "Instalação Elétrica Predial",
        description:
          "Executamos instalações elétricas completas para edifícios residenciais e comerciais, seguindo as normas técnicas de segurança e garantindo máxima eficiência energética.",
        benefits: [
          "Projetos personalizados",
          "Materiais de qualidade",
          "Conformidade com normas",
        ],
        link: "/solicitar-eletrica",
      },
      {
        image: Maintain,
        title: "Manutenção de Sistemas Elétricos",
        description:
          "Serviços de manutenção preventiva e corretiva para sistemas elétricos, identificando e corrigindo falhas antes que se tornem problemas maiores.",
        benefits: [
          "Prevenção de curtos-circuitos",
          "Segurança garantida",
          "Economia de energia",
        ],
        link: "/solicitar-manutencao-eletrica",
      },
      {
        image: Repair,
        title: "Reparação de Circuitos",
        description:
          "Diagnóstico e reparação de circuitos elétricos danificados, substituição de componentes e restauração do funcionamento ideal do sistema.",
        benefits: [
          "Diagnóstico preciso",
          "Reparos rápidos",
          "Componentes originais",
        ],
        link: "/solicitar-reparacao-eletrica",
      },
    ],
  },
  {
    title: "Construção Civil",
    description:
      "Execução de obras de alvenaria estrutural e convencional, reformas residenciais e comerciais, construção de edifícios, acompanhamento técnico de obras, gerenciamento de projetos construtivos e implementação de soluções arquitetônicas personalizadas.",
    icon: faBuilding,
    content: [
      {
        image: Installation,
        title: "Construção de Edifícios",
        description:
          "Desenvolvemos projetos construtivos completos, desde a fundação até o acabamento, com qualidade e dentro dos prazos estabelecidos.",
        benefits: [
          "Projetos personalizados",
          "Materiais de primeira",
          "Prazo garantido",
        ],
        link: "/solicitar-construcao",
      },
      {
        image: Maintain,
        title: "Reformas Residenciais",
        description:
          "Transformamos seu espaço com reformas planejadas e executadas por profissionais qualificados, garantindo resultado final de excelência.",
        benefits: [
          "Design personalizado",
          "Qualidade nos acabamentos",
          "Supervisão técnica",
        ],
        link: "/solicitar-reforma",
      },
      {
        image: Repair,
        title: "Acompanhamento Técnico",
        description:
          "Serviço de gerenciamento e acompanhamento técnico de obras, garantindo que todos os aspectos do projeto sejam executados conforme planejado.",
        benefits: [
          "Fiscalização constante",
          "Cumprimento de normas",
          "Qualidade assegurada",
        ],
        link: "/solicitar-acompanhamento",
      },
    ],
  },
  {
    title: "Hidráulica e Encanamento",
    description:
      "Instalação e manutenção de sistemas hidráulicos completos, reparação de vazamentos, substituição de tubulações, instalação de pontos de água quente e fria, montagem de sistemas de bombeamento e solução de problemas em redes de esgoto e águas pluviais.",
    icon: faFaucet,
    content: [
      {
        image: Installation,
        title: "Instalação Hidráulica Completa",
        description:
          "Instalação de sistemas hidráulicos residenciais e comerciais, incluindo redes de água fria, quente e esgoto.",
        benefits: [
          "Materiais duráveis",
          "Instalação profissional",
          "Teste de pressão",
        ],
        link: "/solicitar-hidraulica",
      },
      {
        image: Maintain,
        title: "Reparação de Vazamentos",
        description:
          "Identificação e reparação rápida de vazamentos em tubulações, torneiras, registros e demais componentes hidráulicos.",
        benefits: [
          "Atendimento emergencial",
          "Solução definitiva",
          "Limpeza do local",
        ],
        link: "/solicitar-reparo-hidraulico",
      },
      {
        image: Repair,
        title: "Sistemas de Bombeamento",
        description:
          "Instalação e manutenção de sistemas de bombeamento para abastecimento de água e pressurização.",
        benefits: [
          "Equipamentos eficientes",
          "Manutenção preventiva",
          "Redução de custos",
        ],
        link: "/solicitar-bombeamento",
      },
    ],
  },
  {
    title: "Aplicação de Revestimentos",
    description:
      "Serviços especializados em aplicação de reboco, chapisco, emboço e acabamentos em gesso, realização de texturas decorativas, impermeabilização de fachadas, reparação de trincas e fissuras, e aplicação de revestimentos cerâmicos e porcelanatos.",
    icon: faPaintRoller,
    content: [
      {
        image: Installation,
        title: "Acabamentos em Gesso",
        description:
          "Aplicação profissional de acabamentos em gesso para forros, sancas e divisórias, criando ambientes elegantes e funcionais.",
        benefits: ["Design moderno", "Acabamento perfeito", "Durabilidade"],
        link: "/solicitar-gesso",
      },
      {
        image: Maintain,
        title: "Revestimentos Cerâmicos",
        description:
          "Instalação de revestimentos cerâmicos e porcelanatos com técnica apurada, garantindo perfeito alinhamento e durabilidade.",
        benefits: [
          "Assentamento preciso",
          "Juntas uniformes",
          "Limpeza profissional",
        ],
        link: "/solicitar-ceramica",
      },
      {
        image: Repair,
        title: "Impermeabilização",
        description:
          "Serviços de impermeabilização de fachadas, terraços e áreas molhadas, protegendo sua construção contra infiltrações.",
        benefits: [
          "Produtos de qualidade",
          "Aplicação técnica",
          "Garantia de proteção",
        ],
        link: "/solicitar-impermeabilizacao",
      },
    ],
  },
  {
    title: "Instalação de Racks e Estruturas",
    description:
      "Montagem e instalação de racks industriais e comerciais, estruturas metálicas personalizadas, organização de espaços de armazenamento, implementação de sistemas de paletização e soluções de armazenagem logística para diversos segmentos empresariais.",
    icon: faWarehouse,
    content: [
      {
        image: Installation,
        title: "Racks Industriais",
        description:
          "Instalação de sistemas de racks industriais para otimização de espaço e organização de estoques em armazéns e galpões.",
        benefits: [
          "Maximização de espaço",
          "Segurança estrutural",
          "Personalização",
        ],
        link: "/solicitar-racks",
      },
      {
        image: Maintain,
        title: "Estruturas Metálicas",
        description:
          "Projeto e montagem de estruturas metálicas personalizadas para diversos fins industriais e comerciais.",
        benefits: [
          "Projeto customizado",
          "Materiais resistentes",
          "Montagem profissional",
        ],
        link: "/solicitar-estruturas",
      },
      {
        image: Repair,
        title: "Sistemas de Armazenagem",
        description:
          "Implementação de sistemas completos de armazenagem logística para empresas de diversos segmentos.",
        benefits: [
          "Otimização de processos",
          "Aumento de produtividade",
          "Soluções integradas",
        ],
        link: "/solicitar-armazenagem",
      },
    ],
  },
];

export const Parceiros = [
  {
    id: 1,
    name: "Alcaal",
    image: Alcaal,
  },
  {
    id: 2,
    name: "Capricha",
    image: Capricha,
  },
  {
    id: 3,
    name: "GEDS",
    image: GEDS,
  },
  {
    id: 4,
    name: "Idalzira",
    image: Idalzira,
  },
  {
    id: 5,
    name: "Oasis",
    image: Oasis,
  },
  {
    id: 6,
    name: "TextAng",
    image: TextAng,
  },
  {
    id: 7,
    name: "Yurman",
    image: Yurman,
  },
];

export const faqData: IFAQItem[] = [
  // Climatização e Ar Condicionado
  {
    question: "Quanto tempo leva a instalação de um ar condicionado?",
    answer:
      "O tempo de instalação varia conforme o tipo de sistema e complexidade. Para sistemas split residenciais, geralmente levamos de 2 a 4 horas. Sistemas centrais comerciais podem levar de 1 a 3 dias. Nossa equipe avalia previamente o local para dar um prazo mais preciso.",
    category: "climatizacao",
  },
  {
    question:
      "Com que frequência devo fazer a manutenção do meu ar condicionado?",
    answer:
      "Recomendamos manutenção preventiva a cada 6 meses para uso residencial e a cada 3 meses para uso comercial intensivo. A manutenção regular aumenta a vida útil do equipamento em até 40% e reduz o consumo de energia em 15-20%.",
    category: "climatizacao",
  },
  {
    question: "Vocês trabalham com todas as marcas de ar condicionado?",
    answer:
      "Sim, somos especializados em todas as principais marcas do mercado: Gree, Samsung, LG, Springer, Midea, entre outras. Nossos técnicos são certificados e possuem treinamento específico para cada fabricante.",
    category: "climatizacao",
  },
  {
    question: "O que fazer se meu ar condicionado estiver vazando água?",
    answer:
      "Vazamentos geralmente indicam dreno entupido ou problemas na bandeja de condensação. Desligue o equipamento e entre em contato conosco imediatamente. Não tente resolver sozinho, pois pode agravar o problema ou causar danos elétricos.",
    category: "climatizacao",
  },

  // Serviços Elétricos
  {
    question:
      "Vocês fazem instalações elétricas completas para novas construções?",
    answer:
      "Sim, executamos projetos elétricos completos desde a fundação, incluindo quadro de distribuição, pontos de energia, iluminação, tomadas e sistemas de aterramento. Trabalhamos conforme as normas técnicas angolanas de segurança.",
    category: "eletrica",
  },
  {
    question: "O que inclui uma manutenção preventiva elétrica?",
    answer:
      "Nossa manutenção preventiva inclui: verificação de tensão, inspeção de quadros elétricos, teste de disjuntores, verificação de aterramento, análise de pontos de sobrecarga e identificação de possíveis riscos. Garantimos a segurança total da sua instalação.",
    category: "eletrica",
  },
  {
    question: "Vocês emitem certificado de conformidade elétrica?",
    answer:
      "Sim, após a conclusão de qualquer serviço elétrico, emitimos certificado de conformidade atestando que a instalação está dentro das normas de segurança. Este documento é essencial para seguros e financiamentos imobiliários.",
    category: "eletrica",
  },

  // Construção Civil
  {
    question: "Quanto tempo leva uma reforma residencial média?",
    answer:
      "O prazo depende do escopo do projeto. Reformas simples (1-2 cômodos) levam de 2 a 4 semanas. Reformas completas podem levar de 2 a 6 meses. Desenvolvemos um cronograma detalhado antes de iniciar qualquer obra.",
    category: "construcao",
  },
  {
    question: "Vocês fornecem projeto arquitetônico?",
    answer:
      "Sim, temos parceria com arquitetos e engenheiros para desenvolvimento de projetos completos, incluindo plantas, especificações técnicas e acompanhamento da obra. Oferecemos pacotes completos 'chave na mão'.",
    category: "construcao",
  },
  {
    question: "Como é calculado o orçamento de uma construção?",
    answer:
      "Nosso orçamento considera: custos de materiais, mão de obra especializada, equipamentos, projetos técnicos, licenças e margem para imprevistos. Fornecemos planilha detalhada com todos os itens para sua análise.",
    category: "construcao",
  },

  // Hidráulica
  {
    question: "Como identificar vazamentos ocultos?",
    answer:
      "Utilizamos equipamentos de detecção por ultrassom e geofones para identificar vazamentos ocultos sem quebrar paredes desnecessariamente. Também analisamos contas de água para detectar consumo anormal.",
    category: "hidraulica",
  },
  {
    question: "Vocês fazem substituição completa de tubulações?",
    answer:
      "Sim, realizamos a substituição completa de sistemas hidráulicos antigos por novos, utilizando materiais de alta durabilidade como PPR e PVC. Trabalhamos com mínimo de quebra-quebra possível.",
    category: "hidraulica",
  },

  // Geral e Atendimento
  {
    question: "Os orçamentos são gratuitos?",
    answer:
      "Sim, todos os nossos orçamentos e visitas técnicas são completamente gratuitas. Analisamos sua necessidade no local e fornecemos proposta detalhada sem qualquer compromisso.",
    category: "geral",
  },
  {
    question: "Qual a área de atendimento da Clima Tropical?",
    answer:
      "Atendemos em toda Luanda e áreas metropolitanas. Para outras províncias, avaliamos caso a caso. Temos equipes móveis preparadas para deslocamento em todo território angolano.",
    category: "geral",
  },
  {
    question: "Vocês oferecem garantia nos serviços?",
    answer:
      "Sim, oferecemos garantia de 12 meses para serviços de climatização e 6 meses para demais serviços. Todos os materiais utilizados possuem garantia do fabricante, que varia conforme o produto.",
    category: "geral",
  },
  {
    question: "Como agendar um atendimento?",
    answer:
      "Você pode agendar através do nosso WhatsApp (+244 222 678 777), telefone, email ou formulário no site. Respondemos em até 2 horas úteis e marcamos a visita conforme sua disponibilidade.",
    category: "geral",
  },
  {
    question: "Trabalhamos em fins de semana e feriados?",
    answer:
      "Sim, oferecemos plantão 24 horas para emergências em climatização e serviços elétricos. Para serviços agendados, trabalhamos de segunda a sábado, das 8h às 18h.",
    category: "geral",
  },
  {
    question: "Quais são as formas de pagamento aceitas?",
    answer:
      "Aceitamos transferência bancária, dinheiro e cheque. Para projetos maiores, oferecemos parcelamento em até 12 vezes. Todos os valores são discutidos e aprovados antes do início dos serviços.",
    category: "geral",
  },
];


export const contactsData=[
  {
    label: 'Telefone',
    value: '(+244) 941 392 971'
  },
  {
    label: 'E-mail',
    value: 'climatropical787@gmail.com'
  },
  {
    label: 'WhatsApp',
    value: '(+244) 941 392 971'
  }
]